function PropertyLoadingState() {
  return (
    <div className="min-h-screen text-[#183228]">
      <main className="mx-auto w-[min(900px,calc(100%-40px))] py-12">
        <section className="rounded-[28px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] p-8 shadow-[0_22px_60px_rgba(24,50,40,0.08)]">
          Laster eiendom...
        </section>
      </main>
    </div>
  );
}

export default PropertyLoadingState;